<template>
  <div>
    <div class="banner">
      <img src="/static/images/banner-news.png">
    </div>
    <div class="width1200">
      <el-tabs class="news-tab" v-model="tab" @tab-click="tabChange">
        <el-tab-pane label="全部" name="0"></el-tab-pane>
        <el-tab-pane label="企业动态" name="1"></el-tab-pane>
        <el-tab-pane label="行业动态" name="2"></el-tab-pane>
      </el-tabs>
      <div class="news el-row--flex is-justify-space-between is-align-middle" v-for="(item, index) in newsList" :key="index" @click="toDetail(index)">
        <img :src="$global.imageUrl + item.pics" class="news-img">
        <div class="news-content">
          <div class="news-content-title">{{item.title}}</div>
          <div class="news-content-detail">{{item.digest}}</div>
          <div class="news-content-label">{{item.type == 1 ? "企业动态" : item.type == 2 ? "行业动态" : ""}}</div>
        </div>
        <div class="news-date">
          <div class="news-date-month">{{item.month}}</div>
          <div class="news-date-year">{{item.year}}</div>
          <img src="/static/images/to-news-detail.png" class="news-date-img">
        </div>
      </div>
      <el-pagination
        :current-page="currentPage"
        :page-size="6"
        layout="prev, pager, next"
        :total="newsList.length"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tab: 0,
        newsList: [],
        currentPage: 1,
        totalSize: '10'
      }
    },
    mounted() {
      if (this.$global.getUrlKey("tab")) {
        this.tab = this.$global.getUrlKey("tab");
      }
      this.refresh();
    },
    methods: {
      refresh() {
      	this.$global.axios.get(this, "/sywl/news/listPage", {
      		type: 0 == this.tab ? "" : this.tab,
      		page: this.currentPage,
      		limit: this.totalSize
      	}, res => {
          const that = this;
      		res.data.forEach(function(ele) {
      			ele.content = ele.content.replace(/<[^>]*>|<\/[^>]*>/gm, "");
            ele.month = that.$global.format(ele.dtCreate, "MM-dd");
            ele.year = that.$global.format(ele.dtCreate, "yyyy")
      		});
          this.newsList = res.data;
      	})
      },
      toDetail(index) {
      	this.$router.push("/news/detail?id=" + this.newsList[index].id)
      },
      tabChange(e) {
      	this.tab = e.index;
        this.refresh();
      },
      pageChange(t) {
      	this.currentPage = t;
        this.refresh();
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-tabs {
    &.news-tab {
      margin-top: 22px;

      .el-tabs__item {
        width: 96px;
        height: auto;
        padding: 10px 0;
        font-size: 24px;
        color: #333;

        & + .el-tabs__item {
          margin-left: 46px;
        }

        &.is-active {
          border-bottom: 2px solid #1875f0;
        }
      }

      .el-tabs__active-bar {
        display: none;
      }

      .el-tabs__nav-wrap:after {
        background-color: transparent;
      }
    }
  }

  .news {
    padding: 16px 56px 16px 16px;
    background-color: #f2f2f2;
    margin-top: 30px;

    &:hover {
      box-shadow: 0 10px 10px 0 hsla(0,0%,60%,.25);
    }

    & + & {
      margin-top: 16px;
    }

    &-img {
      width: 259px;
      height: 146px;
      margin-right: 24px;
    }

    &-content {
      width: calc(100% - 408px);
      text-align: left;

      &-title {
        margin-bottom: 20px;
        font-size: 18px;
        color: #333;
      }

      &-detail {
        margin-bottom: 28px;
        font-size: 14px;
        color: #333
      }

      &-label {
        font-size: 14px;
        color: #999;
      }
    }

    &-date {
      margin-left: 63px;
      text-align: left;
      color: #999;

      &-month {
        font-size: 20px;
      }

      &-year {
        font-size: 13px;
      }

      &-img {
        margin-top: 24px;
      }
    }
  }

  .el-pagination {
    margin: 68px auto 86px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/news.vue